import { useDispatch, useSelector } from 'react-redux';

export const useAppSelector = useSelector;
export const useAppDispatch = () => useDispatch();
